import script from "./BackTop.vue?vue&type=script&lang=ts&setup=true"
export * from "./BackTop.vue?vue&type=script&lang=ts&setup=true"

import "./BackTop.vue?vue&type=style&index=0&id=a7673d0e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7673d0e"]])

export default __exports__